import debug from 'debug'

import axios from 'axios'
import Config from '@/config/'

let log = debug('store:root')

const root = {
  strict: true,

  state: {
    site: null,
    loading: true,
    pageData: {},
  },

  mutations: {
    SET_SITE (state, site) {
      state.site = site
      log('mutation SET_SITE', state)
    },
    SET_LOADING (state, { loading }) {
      state.loading = loading
      log('mutation SET_LOADING', state)
    },
    SET_PAGE_DATA (state, data) {
      state.pageData[data.name] = { ...data.data }
    },
  },

  actions: {
    init ({ commit }, site) {
      log('action init', site)
      commit('SET_SITE', site)
    },
    setLoading ({ commit }, loading) {
      log('action loading', loading)
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', { loading })
        resolve(loading)
      })
    },
    setPageData ({ commit, dispatch, state }, { name, path, token, preview }) {
      if (state.pageData[name]) {
        return new Promise(function (resolve) {
          resolve(state.pageData[name])
        })
      }

      return axios
        .get(`${Config.get('apiBase')}${path}`, {
          params: {
            token: token,
            preview: preview,
          },
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(response => {
          let data = response.data
          commit('SET_PAGE_DATA', { data, name })
          dispatch('setLoading', false)
          return data
        })
    },
  },
}

export default root
